import { render, staticRenderFns } from "./batchPrePayFeeDialog.vue?vue&type=template&id=cb2067be&scoped=true"
import script from "./batchPrePayFeeDialog.vue?vue&type=script&lang=js"
export * from "./batchPrePayFeeDialog.vue?vue&type=script&lang=js"
import style0 from "./batchPrePayFeeDialog.vue?vue&type=style&index=0&id=cb2067be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2067be",
  null
  
)

export default component.exports